import type { ReactNode } from "react";

interface MatchBoxProps {
  /** Finishes "Matches headlines that…": "mention any of these keywords". */
  title: ReactNode;
  /** For the landmark: "Keywords". */
  label: string;
  /** Beside the title, e.g. "Upload CSV". */
  action?: ReactNode;
  /** The chips and the typing field, wrapping as one field. */
  field: ReactNode;
  /** Under the field: checks, the CSV step, tag suggestions. */
  children?: ReactNode;
}

/**
 * One of the three boxes. Its title finishes the heading's sentence, so the
 * boxes read top to bottom as the rule they make, and each takes its own
 * kind of entry — typed, pasted, or picked on the left.
 */
export default function MatchBox({ title, label, action, field, children }: MatchBoxProps) {
  return (
    <section
      aria-label={label}
      className="flex flex-col gap-2.5 rounded-md border border-gray-700 bg-gray-800/45 px-3.5 py-3"
    >
      <div className="flex min-h-[22px] items-center gap-2">
        <h3 className="m-0 flex-1 text-sm font-medium leading-snug text-gray-100">{title}</h3>
        {action}
      </div>
      <div className="flex flex-wrap items-center gap-1.5">{field}</div>
      {children}
    </section>
  );
}
